import { productTaxonomyCopyCatalog, productTaxonomyTermCatalog } from './renames';
import type { ProductTaxonomyCopyTermReference, ProductTaxonomyVariant } from './types';

export type { ProductTaxonomyVariant } from './types';

export type ProductTaxonomyTermKey = keyof typeof productTaxonomyTermCatalog;
type ProductTaxonomyTermEntry = (typeof productTaxonomyTermCatalog)[ProductTaxonomyTermKey][ProductTaxonomyVariant];
export type ProductTaxonomyTermFormKey = keyof ProductTaxonomyTermEntry;
export type ProductTaxonomyTermReference = `${ProductTaxonomyTermKey & string}.${ProductTaxonomyTermFormKey & string}`;

export type ProductTaxonomyCopyKey = keyof typeof productTaxonomyCopyCatalog;

export function resolveProductTaxonomyTerm(
  reference: ProductTaxonomyTermReference,
  variant: ProductTaxonomyVariant,
): string {
  const [termKey, formKey] = reference.split('.') as [ProductTaxonomyTermKey, ProductTaxonomyTermFormKey];
  return productTaxonomyTermCatalog[termKey][variant][formKey];
}

export function resolveProductTaxonomyCopy(key: ProductTaxonomyCopyKey, variant: ProductTaxonomyVariant): string {
  const entry = productTaxonomyCopyCatalog[key];

  if ('term' in entry) {
    return resolveProductTaxonomyCopyTerm(entry.term, variant);
  }

  return entry[variant];
}

function resolveProductTaxonomyCopyTerm(
  reference: ProductTaxonomyCopyTermReference,
  variant: ProductTaxonomyVariant,
): string {
  const [termKey, formKey] = reference.split('.') as [string, ProductTaxonomyTermFormKey];
  const value = productTaxonomyTermCatalog[termKey as ProductTaxonomyTermKey]?.[variant][formKey];

  if (value == null) {
    throw new Error(`Unknown product taxonomy term reference: ${reference}`);
  }

  return value;
}
